import { setUser } from "@sentry/solid";
import { useAuthState } from "../state/auth";
import { createEffect, createResource } from "solid-js";
import UserService from "./UserService";
import { isNil } from "lodash-es";

const init = () => {
  const { loginStatus } = useAuthState();
  const [user] = createResource(loginStatus, () => {
    if (loginStatus() === "loggedIn") {
      return UserService.getUser();
    }
  });

  createEffect(() => {
    const userData = user()?.data;
    if (!isNil(userData) && loginStatus() === "loggedIn") {
      setUser({ id: userData.id.toString(), ip_address: undefined });
    }
  });

  createEffect(() => {
    if (loginStatus() === "loggedOut") {
      setUser(null);
    }
  });
};

export default { init };
